import { render, staticRenderFns } from "./No02.vue?vue&type=template&id=dcbdcaca&scoped=true"
import script from "./No02.vue?vue&type=script&lang=js"
export * from "./No02.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcbdcaca",
  null
  
)

export default component.exports